"use client";

import { Box, Flex, Text } from "@chakra-ui/react";
import { useTranslations } from "next-intl";
import { ScrollReveal } from "./ScrollReveal";

export function LandingTestimonialBlock() {
  const t = useTranslations("landing.testimonial");

  return (
    <Box
      as="section"
      aria-labelledby="landing-quote-heading"
      bg="neutral.900"
      py={{ base: 16, md: 25 }}
      px={{ base: 4, md: 10 }}
    >
      <ScrollReveal>
        <Box maxW="800px" mx="auto" textAlign="center">
          <Text
            fontFamily="heading"
            textStyle="4xl"
            color="primary.500"
            lineHeight={1}
            mb={0}
            opacity={0.6}
            aria-hidden
          >
            &ldquo;
          </Text>
          <Text
            as="p"
            id="landing-quote-heading"
            fontFamily="heading"
            textStyle="xl"
            fontWeight="bold"
            color="white"
            lineHeight={1.3}
            letterSpacing="-0.5px"
            mb={7}
          >
            {t("quote")}
          </Text>
          <Flex
            as="cite"
            textStyle="xs"
            color="whiteAlpha.400"
            fontStyle="normal"
            alignItems="center"
            justify="center"
            gap={2.5}
            _before={{
              content: '""',
              w: "20px",
              h: "1px",
              bg: "whiteAlpha.200",
            }}
            _after={{
              content: '""',
              w: "20px",
              h: "1px",
              bg: "whiteAlpha.200",
            }}
          >
            {t("name")}
          </Flex>
        </Box>
      </ScrollReveal>
    </Box>
  );
}
